import { createFileRoute, Outlet, type ParsedLocation, redirect } from '@tanstack/react-router';
import { RouterContext } from '@/router';

export const Route = createFileRoute('/dashboard')({
  component: DashboardLayout,
  beforeLoad: ({ context, location }: { context: RouterContext; location: ParsedLocation }) => {
    const { isAuthenticated, isLoading } = context.auth;

    // If not authenticated and not currently loading auth status, redirect to login
    if (!isLoading && !isAuthenticated) {
      return;
    }

    if (location.pathname === '/dashboard' || location.pathname === '/dashboard/') {
      throw redirect({
        to: '/',
      });
    }
  },
});

function DashboardLayout() {
  return <Outlet />;
}
